import _mock from './_mock';

// ----------------------------------------------------------------------

export * from './_app';
export * from './_user';
export * from './_plans';
export * from './_others';
export * from './_booking';
export * from './_banking';
export * from './_ecommerce';
export * from './_analytics';
export * from './_countries';
export * from './_top100Films';

export default _mock;
